import initCleanAirZone from './initCleanAirZone';
import initCleanAirZoneMap from './clean-air-zone-map';

const cleanAirZone = document.querySelectorAll('.cms-content-slice-clean-air-zone');
const cleanAirZoneLength = cleanAirZone.length;
if (cleanAirZoneLength > 0) {
    for (let index = 0; index < cleanAirZoneLength; index++) {
        initCleanAirZone(cleanAirZone[index]);
    }
}

const cleanAirZoneMap = document.querySelector('.cms-content-slice-clean-air-zone-map__el');
if (cleanAirZoneMap) {
    const cleanAirZoneMapObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initCleanAirZoneMap(entry.target);
                cleanAirZoneMapObserver.unobserve(entry.target);
            }
        })
    })

    cleanAirZoneMapObserver.observe(cleanAirZoneMap);
}